import { createAction, handleActions } from "redux-actions";
import _includes from "lodash/includes";
//
import { createPromiseActionTypes } from "../utils/redux";
import Api from "../services/Api";
import { goToBack } from "./modal";
import { AJAX_ERROR, ajaxPendingAction, ajaxErrorAction } from "./ajax";
import { INTL_CITY_SET } from "./intl";
import { getModelsIfNeededAction } from "./models/actions";

//  Actions Types
export const LOCATION_GET = createPromiseActionTypes("locations/LOCATION_GET");
export const LOCATION_STORE = createPromiseActionTypes(
  "locations/LOCATION_STORE"
);
const LOCATION_SET = "locations/LOCATION_SET";
const LOCATION_FEE = createPromiseActionTypes("locations/LOCATION_FEE");

//  Actions
const getLocationFulfilledAction = createAction(LOCATION_GET.FULFILLED);
const storeLocationFulfilledAction = createAction(LOCATION_STORE.FULFILLED);
const _setLocationAction = createAction(LOCATION_SET);
export const setLocationFeeAction = createAction(LOCATION_FEE.FULFILLED);

export const getLocationAction = (placeId) => async (dispatch, getState) => {
  let notFound = false;
  let location;
  let error;

  dispatch(ajaxPendingAction());

  // 1- Try to fetch existing location
  try {
    location = await Api.getLocation(placeId);
  } catch (err) {
    if (err.response && err.response.status === 404) {
      notFound = true;
    } else {
      error = err;
    }
  }

  // 2- If it does not exist, create it.
  if (notFound) {
    const { uuid } = getState();

    try {
      location = await Api.storeLocation(placeId, uuid);

      // Re-generate UUID
      dispatch(storeLocationFulfilledAction());
    } catch (err) {
      error = err;
    }
  }

  // If no errors
  if (location) {
    dispatch(getLocationFulfilledAction(location));
  }

  if (error && error.data) {
    dispatch(ajaxErrorAction(error.data));
  } else if (error) {
    throw error;
  }
};

export const setLocationAction = (locationId) => async (dispatch, getState) => {
  const { models } = getState();

  dispatch(ajaxPendingAction());

  try {
    const fee = await Api.getLocationFee(locationId, models.active);

    dispatch(_setLocationAction(locationId));
    dispatch(setLocationFeeAction(fee));
    dispatch(goToBack());
  } catch (err) {
    if (err.data) {
      dispatch(ajaxErrorAction(err.data));
    } else {
      throw err;
    }
  }
};

export const forceLocationAction = (locationId) => async (dispatch) => {
  dispatch(_setLocationAction(locationId));
  dispatch(getModelsIfNeededAction());
};

//  Reducer
const initialState = {
  entities: {},
  active: null,
  preview: null,
  fee: 0,
};

const { debug } = window.SERVER;

if (debug) {
  initialState.active = 2;
  initialState.entities = {
    "2": {
      name: "Hotel Novotel Bangkok Ploenchit Sukhumvit",
      placeId: "ChIJvVSoBt2e4jARTkPqaFdcDcI",
      address:
        "566 Phloen Chit Rd, Khwaeng Lumphini, Khet Pathum Wan, Krung Thep Maha Nakhon 10330, Thailand",
      lat: 13.742715,
      lng: 100.549788,
    },
  };
}

export default handleActions(
  {
    [LOCATION_GET.FULFILLED]: applyGetLocation,
    [LOCATION_SET]: applySetLocation,
    [LOCATION_FEE.FULFILLED]: applyGetTravelFeeFullfilled,
    [INTL_CITY_SET]: applyReset,
    [AJAX_ERROR]: applyAjaxError,
  },
  initialState
);

//  Action Reducers
function applyGetLocation(state, action) {
  const { entities, result } = action.payload;

  return {
    ...state,
    entities: { ...state.entities, ...entities.locations },
    preview: result,
  };
}

function applySetLocation(state, action) {
  return {
    ...state,
    active: action.payload,
  };
}

function applyGetTravelFeeFullfilled(state, action) {
  const { fee } = action.payload;

  return { ...state, fee };
}

function applyAjaxError(state, action) {
  const { error } = action.payload;

  if (error !== "location_too_far") {
    return state;
  }

  return applyReset(state, action);
}

function applyReset(state) {
  return {
    ...state,
    active: null,
    fee: 0,
  };
}
